import { useContext, useEffect, useState } from 'react';
import AuthContext from '../../context/AuthProvider';
import { getKustomerToken } from '../../api/Auth';
import {
  startKustomer,
  stopKustomer,
  loginKustomer,
} from '../../utils/kustomer';

/**
 * Componente sin UI que gestiona el ciclo de vida del widget de Kustomer según
 * la sesión del panel. Montado dentro de <AuthProvider> (ver src/index.js) para
 * tener acceso a `datalogin`.
 *
 * - Sin sesión (`!datalogin`) → `stop()`: el bubble no se muestra y no se puede
 *   chatear sin estar logueado.
 * - Con sesión → `start()` + `login({ jwtToken })` (token firmado por el backend)
 *   y se setean los atributos corporativos en el Customer tras el login.
 */
export default function KustomerBootstrap() {
  const { datalogin } = useContext(AuthContext) as any;
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // El widget sólo existe con sesión iniciada.
    if (!datalogin) {
      stopKustomer();
      setIsReady(false);
      return;
    }

    startKustomer(
      () => setIsReady(true),
      () => setIsReady(false),
    );
  }, [datalogin]);

  useEffect(() => {
    if (!isReady || !datalogin) {
      return;
    }

    // Se pide el token JUSTO antes del login para que su `iat` esté fresco
    // (Kustomer exige que sea < 15 min al momento de autenticar). Tras el login,
    // el wrapper setea los atributos corporativos en el Customer.
    loginKustomer(
      async () => {
        const response = await getKustomerToken();
        return response?.token;
      },
      {
        corporateName: datalogin.name,
        corporateId: datalogin.corporate_id,
        userEmail: datalogin?.user_logged?.email ?? datalogin.email,
        userUniqueId: datalogin.user_id,
      },
    );
  }, [isReady, datalogin]);

  return null;
}
